import {useListView} from '../../core/ListViewProvider'
import {ResellerGroupsListToolbar} from './ResellerGroupListToolbar'
import {ResellerGroupsListGrouping} from './ResellerGroupsListGrouping'
import {ResellerGroupsListSearchComponent} from './ResellerGroupsListSearchComponent'

const ResellerGroupsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ResellerGroupsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ResellerGroupsListGrouping /> : <ResellerGroupsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ResellerGroupsListHeader}
